module.exports = __webpack_public_path__ + "img/c1.19752d50.png";